import { call, put, takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { 
  fetchPaymentStatusRequest,
  fetchPaymentStatusSuccess,
  fetchPaymentStatusFailure,
  orderRequest,
  orderSuccess,
  orderFailure,
  PaymentStatusRequest,
  PaymentStatusResponse,
  OrderRequestV2
} from '../slices/orderSlice';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import { shouldSkipApiCalls } from '../../utils/appConfig';

function* fetchPaymentStatusSaga(action: PayloadAction<PaymentStatusRequest>) {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    const response: { data: PaymentStatusResponse } = yield call(request, {
      method: 'GET',
      url: `/pos/order/track?order_id=${action.payload.order_id}`,
    });
    
    yield put(fetchPaymentStatusSuccess(response.data));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch payment status';
    yield put(fetchPaymentStatusFailure(errorMessage));
  }
}

function* orderSaga(action: PayloadAction<OrderRequestV2>): Generator<any, void, any> {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    
    // Simple pass-through to API - payload is already complete from useOrder hook
    const response: { data: { data: any } } = yield call(request, {
      method: 'POST',
      url: `${ENDPOINTS.API_V2_BASE_URL}${ENDPOINTS.ORDER_API_PATH}`,
      data: action.payload,
    });
    
    // Pass the actual order data (response.data.data), not the wrapper
    yield put(orderSuccess(response.data.data));
  } catch (error: any) {
    console.error('❌ [Order Saga] Order failed:', error);
    console.error('❌ [Order Saga] Error details:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
    });
    
    const errorMessage = error.response?.data?.message || error.message || 'Failed to place order';
    yield put(orderFailure(errorMessage));
  }
}

export function* watchOrderSaga() {
  yield takeEvery(fetchPaymentStatusRequest.type, fetchPaymentStatusSaga);
  yield takeEvery(orderRequest.type, orderSaga);
}
